import { instructionData } from '../../utils/const';
import {
	dateDiff,
	getResheduleURL,
	getCancelURL,
	getTaskLink,
	formatDate,
} from '../../utils/commonFunctions';

export const setCourseState = (rawData, state) => {
	const {
		coursedetails: {
			title,
			show_grade_popup,
			video,
			description,
			totalnumberofattempts,
			attempts_completed,
			domain,
			learning_outcomes,
			progressbar,
			units,
			coach_details,
			calendly_url,
			image_url,
			open_date,
			close_date,
			course_type,
			category,
			course_id,
		},
		continue: { attempt_id, element_id, element_name, element_type } = {},
		coursedetails,
		current_unit,
		current_unit_order,
	} = rawData;
	let displayText = '';
	let courseExpMsg = '';
	let warningOnScheduleCall = '';
	let canScheduleCall = '';
	let cancelScheduleId = 0;
	let coachProgress = 0;
	let validityPeriod = 0;
	let validDaysLeft = 0;
	let showCancelPopup = false;
	let isCoachCourse =
		coursedetails.calendly_url !== undefined &&
		coursedetails.calendly_url.length > 0
			? true
			: false;
	if (isCoachCourse) {
		({ displayText, courseExpMsg, showCancelPopup } = getDisplayText(
			coach_details,
			close_date,
		));
		({ warningOnScheduleCall, canScheduleCall } = scheduleCoachCall(
			coach_details,
			calendly_url,
			displayText,
		));
		cancelScheduleId = coach_details.schedule_id;

		var { total_calls, completed_calls } = coach_details;

		validityPeriod = dateDiff('days', close_date, open_date);
		validDaysLeft = dateDiff('days', close_date);

		coachProgress =
			course_type === 'time_based_coach'
				? 100 - parseInt((validDaysLeft / validityPeriod) * 100, 10)
				: course_type === 'call_based_coach'
				? (completed_calls / total_calls) * 100
				: 0;
	}

	let processedData = {
		continueElementDetails: rawData.continue,
		continueAttemptId: attempt_id,
		continueElementId: element_id,
		continueElementName: element_name,
		continueElementType: element_type,
		completedPercent: !isCoachCourse ? progressbar : coachProgress,
		totalAttempts: !isCoachCourse
			? totalnumberofattempts
			: course_type === 'time_based_coach'
			? validityPeriod
			: total_calls,
		coursedetails,
		currentUnitId: current_unit,
		currentUnitOrder: !!current_unit_order ? current_unit_order : -1,
		completedElements: !isCoachCourse
			? attempts_completed
			: course_type === 'time_based_coach'
			? validDaysLeft
			: completed_calls,
		title,
		video,
		isCoachCourse,
		description,
		domain,
		category,
		learningOutcomes: learning_outcomes,
		units,
		coachDetails: coach_details,
		calendlyUrl: calendly_url,
		displayText,
		courseExpMsg,
		warningOnScheduleCall,
		canScheduleCall,
		cancelScheduleId,
		listItem: getFilterList(units),
		imageUrl: image_url,
		courseType: course_type,
		getGrade: show_grade_popup,
		courseSuccess: true,
		showCancelPopup,
		course_id,
	};

	return processedData;
};

const getDisplayText = (coachDetails, closeDate) => {
	let {
		call_time,
		event_id,
		isReschedulable,
		is_b2b_user,
		reschedule_count,
		isCancelRequest,
	} = coachDetails;
	let showCancelPopup = false;

	let courseExpired = false;
	let eventDetailsFromRedirect = localStorage.getItem('courseQueryParams');
	let hasCoachValue = !!call_time;
	var hasEventDetails =
		eventDetailsFromRedirect !== null
			? Object.values(eventDetailsFromRedirect).every(
					(x) => x !== '' && x !== null,
			  )
			: false;
	var startTime = '';
	var endTime = '';
	let displayText = '';
	let courseExpMsg = '';

	if (hasCoachValue) {
		let date = call_time.split('to');
		startTime = date[0];
		endTime = date[1];
	} else if (hasEventDetails) {
		({ startTime, endTime, event_id } = JSON.parse(eventDetailsFromRedirect));

		if (dateDiff('days', startTime, closeDate) >= 0) {
			courseExpired = true;
		}
		hasEventDetails = false;
		localStorage.removeItem('courseQueryParams');
	}
	if (hasCoachValue || hasEventDetails) {
		if (dateDiff('days', startTime) <= (is_b2b_user ? 0 : 1)) {
			isReschedulable = false;
		}

		let scheduledTime = `${formatDate(startTime, 'DD-MM-yyyy')}, ${formatDate(
			startTime,
			'hh:mm A',
		)} to ${formatDate(endTime, 'hh:mm A')}`;
		let rescheduleURL = getResheduleURL(event_id);

		let cancelURL = '';
		if (is_b2b_user) {
			showCancelPopup = true;
		} else {
			cancelURL = `${getCancelURL(event_id)}`;
		}
		let rescheduleText = '';
		let cancelText = '';

		//set display text
		if (is_b2b_user) {
			if (reschedule_count > 0) {
				cancelText = `Do you want to ${getTaskLink(
					cancelURL,
					'Cancel',
				)} your call?`;
			} else {
				cancelText =
					'You cannot cancel your call as you have exceeded your reschedule count.';
			}
		} else if (isReschedulable) {
			rescheduleText = `Do you want to ${getTaskLink(
				rescheduleURL,
				'Reschedule',
			)} or`;
			cancelText = ` ${getTaskLink(cancelURL, 'Cancel')} your call?`;
		} else {
			rescheduleText = `You cannot reschedule your call within 48hrs of scheduled time.`;
			cancelText = `Do you want to ${getTaskLink(cancelURL, 'Cancel')} your call?`;
		}

		if (is_b2b_user && !!call_time && isCancelRequest) {
			displayText = `Your cancel request for the next call scheduled on ${scheduledTime} is still in process.`;
		} else {
			displayText = `Your next call is scheduled on ${scheduledTime}. 
                        We’ll call you then! </br></br> ${rescheduleText} ${cancelText}`;
		}
	} else if (courseExpired) {
		courseExpMsg = `You cannot schedule a call beyond your course expiry date.`;
	}

	return { displayText, courseExpMsg, showCancelPopup };
};

export const setFetchAttemptSuccess = (rawData) => {
	const { answers, attempt } = rawData;

	let data = {
		showReview: true,
		reviewAnswers: answers,
		reviewAttemptDetails: attempt,
	};
	return data;
};

export const setFetchInstruction = ({
	rawData,
	attemptRemaining,
	elementId,
	courseId,
}) => {
	const {
		domains,
		element_name,
		cert_eligible,
		number_of_questions,
		review_attempts,
		continue_attempt_id,
		hide_start,
		time_limit,
		unit_name,
		element_type,
		element_theme,
	} = rawData;

	let { instrnClassName, instrnIdName, instrnImage } =
		element_type === 'W'
			? instructionData[element_type][element_theme]
			: instructionData[element_type];

	instrnImage =
		element_type === 'S' && cert_eligible === 1 ? 'summativetest_certi.png' : '';

	return {
		speechCheckPass: false,
		certEligible: cert_eligible,
		instrnClassName,
		instrnIdName,
		instrnImage,
		elementId,
		elementName: element_name,
		elementTheme: element_theme,
		elementType: element_type,
		totalQuestion: number_of_questions,
		domains,
		reviewAttemptId: review_attempts,
		continueAttemptId: continue_attempt_id,
		hideStart: hide_start,
		sumTimeLimit: time_limit,
		unitName: unit_name,
		attemptRemaining,
		courseId,
	};
};

export const scheduleCoachCall = (coachDetails, calendlyUrl, displayText) => {
	const { call_status, call_time, task_status } = coachDetails;
	var canScheduleCall = false;
	var warningOnScheduleCall = '';

	//check if user can schedule a call
	if (call_time !== '') {
		warningOnScheduleCall = displayText;
	} else if (
		call_status === '' ||
		(call_status === 'Completed' && task_status === 'Completed')
	) {
		canScheduleCall = true;
	} else if (call_status === 'Completed' && task_status !== 'Completed') {
		warningOnScheduleCall = `Your task is pending. <a href="/submitAssignment">Submit task now.</a>`;
	} else if (call_status === 'InProgress') {
		warningOnScheduleCall = `You have an on-going call with our coach now.`;
	}

	if (localStorage.getItem('isScheduleCall') === 'true') {
		document.getElementsByClassName('panel-course-coach_schedule')[0].click();
		localStorage.removeItem('isScheduleCall');
	}

	return {
		warningOnScheduleCall,
		canScheduleCall,
	};
};

const getFilterList = (units) => {
	let filterItems = [];

	Object.keys(units).forEach((unit) => {
		let elements = units[unit]['course_elements'];
		Object.keys(elements).forEach((element) => {
			filterItems.push(elements[element].element_theme);
		});
	});

	let listItem = Array.from(new Set(filterItems));

	return listItem;
};

export const handleInputChange = (event) => {
	let target = event.target;
	let value = target.value;
	let name = target.name;
	return { [name]: value };
};
